import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M13.077 16.254a.75.75 0 0 1 0 1.492L13 17.75H7a.75.75 0 0 1 0-1.5h6zM17.077 12.254a.75.75 0 0 1 0 1.492L17 13.75H7a.75.75 0 0 1 0-1.5h10z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17 2.25c.199 0 .39.08.53.22L21.061 6l.157.173c.342.418.532.944.532 1.49V19.4a2.35 2.35 0 0 1-2.35 2.35H4.6a2.35 2.35 0 0 1-2.35-2.35V4.6A2.35 2.35 0 0 1 4.6 2.25zM4.6 3.75a.85.85 0 0 0-.85.85v14.8c0 .47.38.85.85.85h14.8c.47 0 .85-.38.85-.85V7.663a.85.85 0 0 0-.192-.539L20 7.062 16.689 3.75H12.75V7A1.75 1.75 0 0 1 11 8.75H8A1.75 1.75 0 0 1 6.25 7V3.75zM7.75 7c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25V3.75h-3.5z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }